import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import TypeFormItems from './TypeFormItems'
import CIMSSection from 'components/CIMSSection'

const RenderFormItems: React.VFC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  return (
    <>
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(event, 'Issue')}
      >
        <CIMSFormItem label="Recipients" name="every">
          <RecipientsSelect />
        </CIMSFormItem>
      </CIMSSection>
      <CIMSSection
        title="Types"
        help={HelpMessage.Issues.Notifications.ByIssueType(event)}
      >
        <CIMSFormItem name="types">
          <TypeFormItems />
        </CIMSFormItem>
      </CIMSSection>
    </>
  )
}

export default RenderFormItems
